// Màn đồng ý lần đầu (Luật BVDLCN 91/2025): phải có sự đồng ý rõ ràng trước khi xử lý dữ liệu
// (camera, ảnh, tài khoản). Lưu phiên bản chính sách đã đồng ý trên máy.

import { h } from './dom';
import { POLICY_VERSION, policyBody } from './screens/privacy';

const KEY = 'booth.consent';

export function hasConsent(): boolean {
  try { return localStorage.getItem(KEY) === POLICY_VERSION; } catch { return true; }
}

/** Resolves once the user agreed. */
export function askConsent(root: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    const policy = h('input', { type: 'checkbox', id: 'c-policy' });
    const age = h('input', { type: 'checkbox', id: 'c-age' });
    const go = h('button.primary', { disabled: true }, 'Đồng ý và tiếp tục');
    const sync = () => { go.disabled = !(policy.checked && age.checked); };
    policy.onchange = sync;
    age.onchange = sync;
    go.onclick = () => {
      try { localStorage.setItem(KEY, POLICY_VERSION); } catch { /* private mode: ask again next time */ }
      resolve();
    };
    root.replaceChildren(h('main.consent', {},
      h('h1', {}, 'Trước khi bắt đầu'),
      h('p', {}, 'Booth Together cần camera và micro để bạn chụp chung với bạn bè. Một vài điều quan trọng:'),
      h('ul', {},
        h('li', {}, h('b', {}, 'Khuôn mặt chỉ xử lý trên máy bạn.'), ' Tách nền và nhận diện tư thế chạy ngay trên điện thoại; không lưu mẫu khuôn mặt lên máy chủ.'),
        h('li', {}, h('b', {}, 'Ảnh của bạn là của bạn.'), ' Chỉ người bạn cho phép mới xem được; bạn có thể tải về hoặc xoá bất cứ lúc nào.'),
        h('li', {}, h('b', {}, 'Lưu trữ an toàn.'), ' Dữ liệu được mã hoá, lưu trên Google Cloud tại Singapore.')),
      // the router is not running yet → show the policy inline instead of navigating
      h('details.card', {}, h('summary', {}, h('b', {}, 'Đọc Chính sách quyền riêng tư')), policyBody()),
      h('label.check', { for: 'c-policy' }, policy, ' Tôi đã đọc và đồng ý Chính sách quyền riêng tư'),
      h('label.check', { for: 'c-age' }, age, ' Tôi từ 16 tuổi trở lên, hoặc đã được cha mẹ/người giám hộ đồng ý'),
      go));
  });
}
